import i18next from 'i18next';
import { CarsConstatns } from '../../Components/Search/Constants';

export const defaultDisplaynameTranslation = (f: string) => {
  switch (f) {
    case CarsConstatns.MANUFACTURER:
    case CarsConstatns.MODEL_SERIES:
    case CarsConstatns.FUEL_TYPE:
    case CarsConstatns.GEARBOX_TYPE:
    case CarsConstatns.SEGMENT:
    case CarsConstatns.DRIVING_WHEEL:
    case CarsConstatns.ENVIRONMENT_CLASS:
    case CarsConstatns.COLOR:
    case CarsConstatns.PRICE:
    case CarsConstatns.LEASING_PRICE:
    case CarsConstatns.BRANCH:
    case CarsConstatns.MILEAGE:
    case CarsConstatns.MODEL_YEAR:
      return i18next.t(`filter.${f}`);
    default:
      return f;
  }
};
